// GENERATED FILE — do not edit by hand.
// Source: reference/budget-codes.csv
// Regenerate: node scripts/generateSeedCodes.mjs
//
// Matt's 11 budget codes, loaded by the first-run setup screen
// (REQUIREMENTS.md §13 Phase 1). Beginning balances are deliberately absent —
// they change every fiscal year and are entered in-app during setup.

import type { Category, Fund } from '../schema/common.js'

export interface SeedBudgetCode {
  code: string
  shortLabel: string
  displayName: string
  fund: Fund
  category: Category
  aliases: string[]
}

export const SEED_BUDGET_CODES: readonly SeedBudgetCode[] = [
  {
    code: '10-2818-329-000-00-000-000-329-0000',
    shortLabel: 'Prof. Ed. Services',
    displayName: 'Professional Educational Services (Consultants)',
    fund: 'main',
    category: 'services',
    aliases: [
      '329'
    ]
  },
  {
    code: '10-2818-360-000-00-000-000-329-0000',
    shortLabel: 'Prof. Dev. Fees',
    displayName: 'Professional Development Fees (Registration)',
    fund: 'main',
    category: 'conference',
    aliases: [
      '360'
    ]
  },
  {
    code: '10-2818-538-000-00-000-000-329-0000',
    shortLabel: 'Telecom',
    displayName: 'Telecom Services',
    fund: 'main',
    category: 'tech',
    aliases: [
      '538'
    ]
  },
  {
    code: '10-2818-580-000-00-000-000-329-0000',
    shortLabel: 'Travel',
    displayName: 'Travel (Transportation, Lodging, Meals)',
    fund: 'main',
    category: 'travel',
    aliases: [
      '580',
      'travel'
    ]
  },
  {
    code: '10-2818-610-000-00-000-000-329-0000',
    shortLabel: 'General Supplies',
    displayName: 'General Supplies',
    fund: 'main',
    category: 'other',
    aliases: [
      '610',
      'supplies'
    ]
  },
  {
    code: '10-2818-635-000-00-000-000-329-0000',
    shortLabel: 'Meals/Refresh',
    displayName: 'Meals/Refreshments',
    fund: 'main',
    category: 'meals',
    aliases: [
      '635',
      'meals'
    ]
  },
  {
    code: '10-2818-640-000-00-000-000-329-0000',
    shortLabel: 'Books/Ref',
    displayName: 'Books/Reference Materials',
    fund: 'main',
    category: 'other',
    aliases: [
      '640',
      'books'
    ]
  },
  {
    code: '10-2818-650-000-00-000-000-329-0000',
    shortLabel: 'Tech Supplies',
    displayName: 'Tech Supplies/Fees',
    fund: 'main',
    category: 'tech',
    aliases: [
      '650',
      'tech-supplies'
    ]
  },
  {
    code: '10-2818-758-000-00-000-000-329-0000',
    shortLabel: 'Digital',
    displayName: 'Digital Solutions',
    fund: 'main',
    category: 'tech',
    aliases: [
      '758',
      'digital'
    ]
  },
  {
    code: '10-2818-810-000-00-000-000-329-0000',
    shortLabel: 'Memberships',
    displayName: 'Memberships/Dues',
    fund: 'main',
    category: 'other',
    aliases: [
      '810',
      'dues'
    ]
  },
  {
    code: '10-0499-000-150-00-000-000-150-0000',
    shortLabel: 'FFLS',
    displayName: 'FFLS Grant',
    fund: 'grant',
    category: 'other',
    aliases: [
      'ffls'
    ]
  }
]
